import { CircularProgress, Grid, IconButton, TextField, makeStyles } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { showEditItemsDialog } from "../../../../../items-edit/items-edit-slice";
import { showDeleteItemsDialog } from "../../../../../items-delete/items-delete-slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getItemDetailsDataService } from "./item-information-list-service";
import { db } from "../../../../../../../../firebase";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
      },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    }
}));

const ItemInformationListLoading = (props) => {
    const classes = useStyles();

    return (
        <>
            <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                <CircularProgress color="inherit" />
            </div>
        </>
    );
};

export default ItemInformationListLoading;